import React from 'react';
import PropTypes from 'prop-types';
import { SortingOptions } from '@zocdoc/branding/constants';
import { RadioGroup, Radio } from '@zocdoc/components/src/radio';
import CollapsibleSection from '@zocdoc/components/src/CollapsibleSection';
import { injectIntl, defineMessages } from 'react-intl';
import { SortingEnum } from '../../../../constants';

export const LOCALIZED_STRINGS = defineMessages({
    Title: {
        id: 'Components.RefineSearch.Sorting.Title',
        defaultMessage: 'sort matches by',
    },
});

const Sorting = ({
    intl,
    sortType,
    onChangeCallback,
    defaultOpen,
    trackFilterClickSortMatches = () => {},
    theme,
}) => {
    const title = intl.formatMessage(LOCALIZED_STRINGS.Title);

    const onChange = update => {
        if (update !== sortType) {
            const newState = { sortType: update };
            trackFilterClickSortMatches(update);
            onChangeCallback(newState);
        }
    };

    return (
        <CollapsibleSection
            data-test="search-refine-sort"
            defaultOpen={defaultOpen}
            headerText={title}
        >
            <RadioGroup
                flush
                name="sort"
                onChangeCallback={onChange}
                renderWithoutBox
                selectedValue={sortType || SortingEnum[SortingOptions.Default].value}
            >
                {theme.search.config.sortingOptions.map(key => SortingEnum[key] && (
                    <Radio
                        key={SortingEnum[key].name}
                        data-test={`search-refine-sort-${SortingEnum[key].name}`}
                        text={SortingEnum[key].text}
                        value={SortingEnum[key].value}
                    />
                ))}
            </RadioGroup>
        </CollapsibleSection>
    );
};

Sorting.propTypes = {
    defaultOpen: PropTypes.bool,
    onChangeCallback: PropTypes.func.isRequired,
    sortType: PropTypes.string.isRequired,
    trackFilterClickSortMatches: PropTypes.func,
};

export default injectIntl(Sorting);
